import { render, staticRenderFns } from "./my-transfer.vue?vue&type=template&id=da13f576&scoped=true&"
import script from "./my-transfer.vue?vue&type=script&lang=js&"
export * from "./my-transfer.vue?vue&type=script&lang=js&"
import style0 from "./my-transfer.vue?vue&type=style&index=0&id=da13f576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da13f576",
  null
  
)

export default component.exports